export default function MuiOutlinedInput(theme) {
	return {
		root: {
			'&:hover:not($disabled)': {
				backgroundColor: theme.palette.background.default
			}
		}
	};
}
